import NTopNBottom from "../../components/NTopNBottom";
// 主图
import bannerImg from "../../assets/lolita2022/banner.jpg";
import navColor from "../../assets/lolita2022/nav/color.png";
// 背景
import navBg from "../../assets/lolita2022/nav/nav_bg.png";
// 定位背景
import navBgFixed from "../../assets/lolita2022/nav/nav_fix.png";
// 标题选中文字
import far1 from "../../assets/lolita2022/nav/far1.png";
import far1_active from "../../assets/lolita2022/nav/far1_active.png";
import far2 from "../../assets/lolita2022/nav/far2.png";
import far2_active from "../../assets/lolita2022/nav/far2_active.png";
import far3 from "../../assets/lolita2022/nav/far3.png";
import far3_active from "../../assets/lolita2022/nav/far3_active.png";
import son1 from "../../assets/lolita2022/nav/son1.png";
import son1_active from "../../assets/lolita2022/nav/son1_active.png";
import son2 from "../../assets/lolita2022/nav/son2.png";
import son2_active from "../../assets/lolita2022/nav/son2_active.png";

import calcRemFn from "../calcRem";
// 经典款轻婚纱-单人
const SINGLE_PRO_ID = 95072
// 经典款轻婚纱-闺蜜
const FAMILY_PRO_ID = 106278

const navCss = {
  navCtnInside: {
    'display': 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'height': '80%',
    'box-sizing': 'border-box',
    'padding': calcRemFn(24),
    paddingTop: calcRemFn(28)
  },
  navWrap: {
    minHeight: calcRemFn(154),
    backgroundImage: `url(${navColor})`,
    boxSizing: "border-box",
    marginTop: calcRemFn(0)
  },
  navCtn: {
    height: calcRemFn(154),
    backgroundImage: `url(${navBg})`
  },
  navCtnFixed: {
    height: calcRemFn(154),
    backgroundImage: `url(${navBgFixed})`
  },
  topBtnLayout: {
    'flex': 1,
    'flex-direction': 'column',
    'display': 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'height': calcRemFn(120)
  },
  topBtnBaseCss: {
    width: calcRemFn(77.5),
    height: calcRemFn(22.5),
    marginTop: calcRemFn(6),
    display: 'block'
  },
  bottomBtnLayout: {
    'flex': 1,
    'flex-direction': 'column',
    'display': 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'height': calcRemFn(120)
  },
  bottomBtnBaseCss: {
    width: calcRemFn(77.5),
    height: calcRemFn(22.5),
    marginTop: calcRemFn(6),
    display: 'block'
  },
  thirdBtnLayout: {
    'flex': 1,
    'flex-direction': 'column',
    'display': 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'height': calcRemFn(120)
  },
  thirdBtnBaseCss: {
    width: calcRemFn(77.5),
    height: calcRemFn(22.5),
    marginTop: calcRemFn(6),
    display: 'block'
  },
  LineCss3: {
    width: calcRemFn(.5),
    height: calcRemFn(10),
    backgroundColor: 'rgba(75, 64, 53 ,.7)',
    display: 'block'
  }
};

const navData = {
  // 三级分隔符控件
  showLine3: false,
  component: NTopNBottom,
  top: [
    {
      key: "top1",
      show: true,
      img: far1,
      img_actived: far1_active
    },
    {
      key: "top2",
      show: true,
      img: far2,
      img_actived: far2_active
    },
    {
      key: "top3",
      show: true,
      img: far3,
      img_actived: far3_active
    }
  ],
  bottom: {
    top1: [
      {
        key: "_i1",
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: "_i2",
        show: true,
        img: son2,
        img_actived: son2_active
      }
    ],
    top2: [
      {
        key: "_i1",
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: "_i2",
        show: true,
        img: son2,
        img_actived: son2_active
      }
    ],
    top3: [
      {
        key: "_i1",
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: "_i2",
        show: true,
        img: son2,
        img_actived: son2_active
      }
    ]
  }
};

function handleThirdMap (start = 0, end, thirdNavName, stop) {
  const list = Array.from({ length: end - start }, (x, i) => i + start);
  let flag = 0
  if (stop) flag = stop
  return list.map((j, index) => {
    let n = ((j >= flag) && flag) ? j + 2 : j + 1
    let key = `_t${index + 1}`;
    const img = require(`../../assets/lolita2022/nav/${thirdNavName}_${n}.png`);
    const imgActived = require(`../../assets/lolita2022/nav/${thirdNavName}_${n}_active.png`);
    return {
      key,
      show: true,
      img,
      img_actived: imgActived
    };
  });
}

function handleThirdNav (secoundNav) {
  const thirdNavMap = {};
  for (let firstKey in secoundNav) {
    const navs = secoundNav[firstKey];
    navs.forEach(item => {
      const thirdKey = firstKey + item.key;
      if (firstKey === "top1") {
        if (item.key === "_i1") {
          thirdNavMap[thirdKey] = handleThirdMap(0, 3, "third1");
        } else if (item.key === "_i2") {
          thirdNavMap[thirdKey] = [
            {
              key: "_t1",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/lolita2022/nav/third2_1.png`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/lolita2022/nav/third2_1.png`),
            }
          ]
        }
      } else if (firstKey === "top2") {
        if (item.key === "_i1") {
          thirdNavMap[thirdKey] = handleThirdMap(3, 5, "third1");
        } else if (item.key === "_i2") {
          thirdNavMap[thirdKey] = [
            {
              key: "_t1",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/lolita2022/nav/third2_1.png`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/lolita2022/nav/third2_1.png`),
            }
          ]
        }
      } else if (firstKey === "top3") {
        if (item.key === "_i1") {
          thirdNavMap[thirdKey] = handleThirdMap(5, 8, "third1");
        } else if (item.key === "_i2") {
          thirdNavMap[thirdKey] = [
            {
              key: "_t1",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/lolita2022/nav/third2_1.png`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/lolita2022/nav/third2_1.png`),
            }
          ]
        }
      }
    })
  }
  return thirdNavMap;
}

navData.third = handleThirdNav(navData.bottom);
const pictureList = [];
function handlePictures (pictureList) {
  const pictures = [];
  const pictureListLopp = {
    '1_1': { num: [2, 2,2], prodId: SINGLE_PRO_ID },
    '1_2': { num: [2], prodId: FAMILY_PRO_ID },
    '2_1': { num: [2, 2], prodId: SINGLE_PRO_ID },
    '2_2': { num: [2], prodId: FAMILY_PRO_ID },
    '3_1': { num: [2, 2,2], prodId: SINGLE_PRO_ID },
    '3_2': { num: [2], prodId: FAMILY_PRO_ID },
  }
  for (const key in pictureListLopp) {
    const element = pictureListLopp[key];
    element.num.forEach((item, idx) => {
      pictureList.push({
        key: key + '_' + (idx + 1),
        picNum: item,
        pid: element.prodId
      })
    })
  }
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0 } = item;
    const picList = [];
    Array(picNum)
      .fill(0)
      .forEach((item, index) => {
        picList.push(
          require(`../../assets/lolita2022/ctn/${key}_${index + startIndex + 1}.jpg`)
        );
      });
    const indexArr = key.split("_");
    pictures.push({
      id: pid,
      type: "blue",
      ref: `top${indexArr[0]}_i${indexArr[1]}_t${indexArr[2]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      thirdName: `_t${indexArr[2]}`,
      son: picList
    });
  });
  pictures.unshift(...[
    {
      son: [],
      id: SINGLE_PRO_ID,
      type: "blue",
      ref: `top1_i11_t1`,
      farName: `top1`,
      sonName: `_i1`,
      thirdName: `_t1`,
    },
    {
      son: [],
      id: SINGLE_PRO_ID,
      type: "blue",
      ref: `top1_i13_t1`,
      farName: `top1`,
      sonName: `_i1`,
      thirdName: `_t2`,
    }
  ])
  return pictures;
}
const pictures = handlePictures(pictureList);
function toNewWedding () {
  window.location.href = window.location.origin + window.location.pathname + `?t=${new Date().getTime()}#/theme/weddingDressCooperation20220409`
  // this.$router.push({ path: '/theme/newWedding' })
}

function onlonadFun (_this) {
  _this.toNewWedding = toNewWedding
}

const topDiff = {
  firstSon: "_i1",
  firstThird: "_t1",
  top1_i1_t1: 30,
  top1_i1_t2: 30,
  top1_i1_t3: 30,
  top1_i2_t1: 30,
  top2_i1_t1: 30,
  top2_i1_t2: 30,
  top2_i2_t1: 30,
  top3_i1_t1: 30,
  top3_i1_t2: 30,
  top3_i1_t3: 30,
  top3_i2_t1: 30
};

export default {
  title: "Lolita",
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
  onlonadFun
};
